import { loadable } from "components/SpruceLoader";

export const Waterfall = loadable(() => import("./waterfall/index"));
